import { PAGINATION_CONSTANTS } from '../../constants'
import {
  getDefaultLineOverlay,
  getDefaultMargin,
  getDefaultMarginOverlay,
  getDefaultTypography,
  getDefaultWidthOverlay,
} from '../utils'

export const CardDesignSettings = {
  // width
  'card-design-width': {
    phone: ['100%'],
    'phone-landscape': ['100%'],
    tablet: ['100%'],
    'tablet-landscape': ['100%'],
    desktop: ['50%'],
    tv: ['50%'],
    overflowSetting: getDefaultWidthOverlay,
  },
  'card-design-leading-button-full-width': {
    phone: false,
    'phone-landscape': false,
    tablet: false,
    'tablet-landscape': false,
    desktop: false,
    tv: false,
  },
  'card-design-trailing-button-full-width': {
    phone: false,
    'phone-landscape': false,
    tablet: false,
    'tablet-landscape': false,
    desktop: false,
    tv: false,
  },
  'card-design-search-box': {
    phone: ['100%'],
    'phone-landscape': ['100%'],
    tablet: ['100%'],
    'tablet-landscape': ['100%'],
    desktop: ['100%'],
    tv: ['100%'],
  },

  // media icon
  'card-design-media-icon-color-filled': {
    phone: true,
    'phone-landscape': true,
    tablet: true,
    'tablet-landscape': true,
    desktop: true,
    tv: true,
  },
  // 'card-design-media-icon-color-custom': {
  //   phone: false,
  //   'phone-landscape': false,
  //   tablet: false,
  //   'tablet-landscape': false,
  //   desktop: false,
  //   tv: false,
  // },
  // 'card-design-media-icon-color-column': {
  //   phone: '',
  //   'phone-landscape': '',
  //   tablet: '',
  //   'tablet-landscape': '',
  //   desktop: '',
  //   tv: '',
  // },
  'card-design-media-icon-size': {
    phone: [50],
    'phone-landscape': [50],
    tablet: [50],
    'tablet-landscape': [50],
    desktop: [50],
    tv: [50],
  },
  // 'card-design-media-icon-variant': {
  //   phone: 'filled',
  //   'phone-landscape': 'filled',
  //   tablet: 'filled',
  //   'tablet-landscape': 'filled',
  //   desktop: 'filled',
  //   tv: 'filled',
  // },
  'card-design-media-icon-weight': {
    phone: 200,
    'phone-landscape': 200,
    tablet: 200,
    'tablet-landscape': 200,
    desktop: 200,
    tv: 200,
  },

  // orientation
  'card-design-orientation': {
    phone: 'vertical',
    'phone-landscape': 'vertical',
    tablet: 'vertical',
    'tablet-landscape': 'vertical',
    desktop: 'vertical',
    tv: 'vertical',
  },

  'card-design-media-icon-grade': {
    phone: 0,
    'phone-landscape': 0,
    tablet: 0,
    'tablet-landscape': 0,
    desktop: 0,
    tv: 0,
  },

  // Layout
  'card-default-per-page': {
    phone: PAGINATION_CONSTANTS.DEFAULT_PER_PAGE,
    'phone-landscape': PAGINATION_CONSTANTS.DEFAULT_PER_PAGE,
    tablet: PAGINATION_CONSTANTS.DEFAULT_PER_PAGE,
    'tablet-landscape': PAGINATION_CONSTANTS.DEFAULT_PER_PAGE,
    desktop: PAGINATION_CONSTANTS.DEFAULT_PER_PAGE,
    tv: PAGINATION_CONSTANTS.DEFAULT_PER_PAGE,
  },
  'card-data-num-item': {
    phone: 10,
    'phone-landscape': 10,
    tablet: 10,
    'tablet-landscape': 10,
    desktop: 10,
    tv: 10,
  },
  'card-design-num-cols': {
    phone: 1,
    'phone-landscape': 3,
    tablet: 2,
    'tablet-landscape': 3,
    desktop: 4,
    tv: 4,
  },
  'card-design-column-row': {
    phone: 'column',
    'phone-landscape': 'column',
    tablet: 'column',
    'tablet-landscape': 'column',
    desktop: 'column',
    tv: 'column',
  },
  'card-design-pagination': {
    phone: true,
    'phone-landscape': true,
    tablet: true,
    'tablet-landscape': true,
    desktop: true,
    tv: true,
  },
  'card-design-same-height': {
    phone: true,
    'phone-landscape': true,
    tablet: true,
    'tablet-landscape': true,
    desktop: true,
    tv: true,
  },

  // spacing
  'card-design-margin': {
    phone: getDefaultMargin(),
    'phone-landscape': getDefaultMargin(),
    tablet: getDefaultMargin(),
    'tablet-landscape': getDefaultMargin(),
    desktop: getDefaultMargin(),
    tv: getDefaultMargin(),
    overflowSetting: getDefaultMarginOverlay,
  },
  'card-design-media-margin': {
    phone: getDefaultMargin([0]),
    'phone-landscape': getDefaultMargin([0]),
    tablet: getDefaultMargin([0]),
    'tablet-landscape': getDefaultMargin([0]),
    desktop: getDefaultMargin([0]),
    tv: getDefaultMargin([0]),
  },
  'card-design-headline-margin': {
    phone: getDefaultMargin([10, 0]),
    'phone-landscape': getDefaultMargin([10, 0]),
    tablet: getDefaultMargin([10, 0]),
    'tablet-landscape': getDefaultMargin([10, 0]),
    desktop: getDefaultMargin([10, 0]),
    tv: getDefaultMargin([10, 0]),
  },
  'card-design-group-header-margin': {
    phone: getDefaultMargin([20, 0]),
    'phone-landscape': getDefaultMargin([20, 0]),
    tablet: getDefaultMargin([20, 0]),
    'tablet-landscape': getDefaultMargin([20, 0]),
    desktop: getDefaultMargin([20, 0]),
    tv: getDefaultMargin([20, 0]),
  },
  'card-design-padding': {
    phone: getDefaultMargin([12, 16]),
    'phone-landscape': getDefaultMargin([12, 16]),
    tablet: getDefaultMargin([12, 16]),
    'tablet-landscape': getDefaultMargin([12, 16]),
    desktop: getDefaultMargin([12, 16]),
    tv: getDefaultMargin([12, 16]),
  },
  'card-design-meta-margin': {
    phone: getDefaultMargin([0, 0]),
    'phone-landscape': getDefaultMargin([0, 0]),
    tablet: getDefaultMargin([0, 0]),
    'tablet-landscape': getDefaultMargin([0, 0]),
    desktop: getDefaultMargin([0, 0]),
    tv: getDefaultMargin([0, 0]),
  },
  'card-design-footer-margin': {
    phone: getDefaultMargin([0, 0]),
    'phone-landscape': getDefaultMargin([0, 0]),
    tablet: getDefaultMargin([0, 0]),
    'tablet-landscape': getDefaultMargin([0, 0]),
    desktop: getDefaultMargin([0, 0]),
    tv: getDefaultMargin([0, 0]),
  },
  'card-design-search-margin': {
    phone: getDefaultMargin([0, 0, 12]),
    'phone-landscape': getDefaultMargin([0, 0, 12]),
    tablet: getDefaultMargin([0, 0, 12]),
    'tablet-landscape': getDefaultMargin([0, 0, 12]),
    desktop: getDefaultMargin([0, 0, 0, 10]),
    tv: getDefaultMargin([0, 0, 0, 10]),
  },
  'card-design-filter-margin': {
    phone: getDefaultMargin([0, 0, 12]),
    'phone-landscape': getDefaultMargin([0, 0, 12]),
    tablet: getDefaultMargin([0, 0, 12]),
    'tablet-landscape': getDefaultMargin([0, 0, 12]),
    desktop: getDefaultMargin([0, 0, 12]),
    tv: getDefaultMargin([0, 0, 12]),
  },
  'card-design-item-gap': {
    phone: { value: 10, unit: 'px' },
    'phone-landscape': { value: 10, unit: 'px' },
    tablet: { value: 10, unit: 'px' },
    'tablet-landscape': { value: 10, unit: 'px' },
    desktop: { value: 10, unit: 'px' },
    tv: { value: 10, unit: 'px' },
  },
  'card-design-header-spacing': {
    phone: { value: 8, unit: 'px' },
    'phone-landscape': { value: 8, unit: 'px' },
    tablet: { value: 8, unit: 'px' },
    'tablet-landscape': { value: 8, unit: 'px' },
    desktop: { value: 8, unit: 'px' },
    tv: { value: 8, unit: 'px' },
  },
  'card-design-image-spacing': {
    phone: { value: 8, unit: 'px' },
    'phone-landscape': { value: 8, unit: 'px' },
    tablet: { value: 8, unit: 'px' },
    'tablet-landscape': { value: 8, unit: 'px' },
    desktop: { value: 8, unit: 'px' },
    tv: { value: 8, unit: 'px' },
  },
  'card-design-footer-section-spacing': {
    phone: { value: 8, unit: 'px' },
    'phone-landscape': { value: 8, unit: 'px' },
    tablet: { value: 8, unit: 'px' },
    'tablet-landscape': { value: 8, unit: 'px' },
    desktop: { value: 8, unit: 'px' },
    tv: { value: 8, unit: 'px' },
  },
  'card-design-footer-title-spacing': {
    phone: { value: 8, unit: 'px' },
    'phone-landscape': { value: 8, unit: 'px' },
    tablet: { value: 8, unit: 'px' },
    'tablet-landscape': { value: 8, unit: 'px' },
    desktop: { value: 8, unit: 'px' },
    tv: { value: 8, unit: 'px' },
  },
  'card-design-content-title-spacing': {
    phone: { value: 8, unit: 'px' },
    'phone-landscape': { value: 8, unit: 'px' },
    tablet: { value: 8, unit: 'px' },
    'tablet-landscape': { value: 8, unit: 'px' },
    desktop: { value: 8, unit: 'px' },
    tv: { value: 8, unit: 'px' },
  },
  'card-design-content-subtitle-spacing': {
    phone: { value: 8, unit: 'px' },
    'phone-landscape': { value: 8, unit: 'px' },
    tablet: { value: 8, unit: 'px' },
    'tablet-landscape': { value: 8, unit: 'px' },
    desktop: { value: 8, unit: 'px' },
    tv: { value: 8, unit: 'px' },
  },
  'card-design-supporting-text-spacing': {
    phone: { value: 8, unit: 'px' },
    'phone-landscape': { value: 8, unit: 'px' },
    tablet: { value: 8, unit: 'px' },
    'tablet-landscape': { value: 8, unit: 'px' },
    desktop: { value: 8, unit: 'px' },
    tv: { value: 8, unit: 'px' },
  },
  'card-design-metadata-spacing': {
    phone: { value: 8, unit: 'px' },
    'phone-landscape': { value: 8, unit: 'px' },
    tablet: { value: 8, unit: 'px' },
    'tablet-landscape': { value: 8, unit: 'px' },
    desktop: { value: 8, unit: 'px' },
    tv: { value: 8, unit: 'px' },
  },

  // Aspect Ratio
  'card-design-media-aspect-ratio': {
    phone: '4:3',
    'phone-landscape': '4:3',
    tablet: '4:3',
    'tablet-landscape': '4:3',
    desktop: '4:3',
    tv: '4:3',
  },

  // Alignments
  'card-design-comp-h-align': {
    phone: 'parent',
    'phone-landscape': 'parent',
    tablet: 'parent',
    'tablet-landscape': 'parent',
    desktop: 'parent',
    tv: 'parent',
  },
  'card-design-comp-title-align': {
    phone: 'center',
    'phone-landscape': 'center',
    tablet: 'center',
    'tablet-landscape': 'center',
    desktop: 'center',
    tv: 'center',
  },
  'card-design-group-header-align': {
    phone: 'center',
    'phone-landscape': 'center',
    tablet: 'center',
    'tablet-landscape': 'center',
    desktop: 'center',
    tv: 'center',
  },
  'card-design-header-title-align': {
    phone: 'start',
    'phone-landscape': 'start',
    tablet: 'start',
    'tablet-landscape': 'start',
    desktop: 'start',
    tv: 'start',
  },
  'card-design-header-subtitle-align': {
    phone: 'start',
    'phone-landscape': 'start',
    tablet: 'start',
    'tablet-landscape': 'start',
    desktop: 'start',
    tv: 'start',
  },
  'card-design-title-align': {
    phone: 'start',
    'phone-landscape': 'start',
    tablet: 'start',
    'tablet-landscape': 'start',
    desktop: 'start',
    tv: 'start',
  },
  'card-design-subtitle-align': {
    phone: 'start',
    'phone-landscape': 'start',
    tablet: 'start',
    'tablet-landscape': 'start',
    desktop: 'start',
    tv: 'start',
  },
  'card-design-supporting-text-align': {
    phone: 'start',
    'phone-landscape': 'start',
    tablet: 'start',
    'tablet-landscape': 'start',
    desktop: 'start',
    tv: 'start',
  },
  'card-design-meta-align': {
    phone: 'start',
    'phone-landscape': 'start',
    tablet: 'start',
    'tablet-landscape': 'start',
    desktop: 'start',
    tv: 'start',
  },
  'card-design-action-align': {
    phone: 'start',
    'phone-landscape': 'start',
    tablet: 'start',
    'tablet-landscape': 'start',
    desktop: 'start',
    tv: 'start',
  },
  'card-design-media-align': {
    phone: 'center',
    'phone-landscape': 'center',
    tablet: 'center',
    'tablet-landscape': 'center',
    desktop: 'center',
    tv: 'center',
  },
  'card-design-search-align': {
    phone: 'start',
    'phone-landscape': 'start',
    tablet: 'start',
    'tablet-landscape': 'start',
    desktop: 'start',
    tv: 'start',
  },

  'card-design-pagination-align': {
    phone: 'center',
    'phone-landscape': 'center',
    tablet: 'center',
    'tablet-landscape': 'center',
    desktop: 'center',
    tv: 'center',
  },
  // (nested) typography
  'card-design-typography': {
    'card-design-header-typography': {
      phone: getDefaultTypography('Title Medium'),
      'phone-landscape': getDefaultTypography('Title Medium'),
      tablet: getDefaultTypography('Title Medium'),
      'tablet-landscape': getDefaultTypography('Title Medium'),
      desktop: getDefaultTypography('Title Medium'),
      tv: getDefaultTypography('Title Medium'),
      overflowSetting: {
        phone: getDefaultTypography('Label Medium'),
        'phone-landscape': getDefaultTypography('Label Medium'),
        tablet: getDefaultTypography('Label Medium'),
        'tablet-landscape': getDefaultTypography('Label Medium'),
        desktop: getDefaultTypography('Label Medium'),
        tv: getDefaultTypography('Label Medium'),
      },
      detailPageSetting: {
        phone: getDefaultTypography('Label Medium'),
        'phone-landscape': getDefaultTypography('Label Medium'),
        tablet: getDefaultTypography('Label Medium'),
        'tablet-landscape': getDefaultTypography('Label Medium'),
        desktop: getDefaultTypography('Label Medium'),
        tv: getDefaultTypography('Label Medium'),
      },
    },
    'card-design-subheader-typography': {
      phone: getDefaultTypography('Body Medium'),
      'phone-landscape': getDefaultTypography('Body Medium'),
      tablet: getDefaultTypography('Body Medium'),
      'tablet-landscape': getDefaultTypography('Body Medium'),
      desktop: getDefaultTypography('Body Medium'),
      tv: getDefaultTypography('Body Medium'),
      overflowSetting: {
        phone: getDefaultTypography('Body Small'),
        'phone-landscape': getDefaultTypography('Body Small'),
        tablet: getDefaultTypography('Body Small'),
        'tablet-landscape': getDefaultTypography('Body Small'),
        desktop: getDefaultTypography('Body Small'),
        tv: getDefaultTypography('Body Small'),
      },
    },
    'card-design-title-typography': {
      phone: getDefaultTypography('Body Large'),
      'phone-landscape': getDefaultTypography('Body Large'),
      tablet: getDefaultTypography('Body Large'),
      'tablet-landscape': getDefaultTypography('Body Large'),
      desktop: getDefaultTypography('Body Large'),
      tv: getDefaultTypography('Body Large'),
      overflowSetting: {
        phone: getDefaultTypography('Body Medium'),
        'phone-landscape': getDefaultTypography('Body Medium'),
        tablet: getDefaultTypography('Body Medium'),
        'tablet-landscape': getDefaultTypography('Body Medium'),
        desktop: getDefaultTypography('Body Medium'),
        tv: getDefaultTypography('Body Medium'),
      },
    },
    'card-design-subtitle-typography': {
      phone: getDefaultTypography('Body Medium'),
      'phone-landscape': getDefaultTypography('Body Medium'),
      tablet: getDefaultTypography('Body Medium'),
      'tablet-landscape': getDefaultTypography('Body Medium'),
      desktop: getDefaultTypography('Body Medium'),
      tv: getDefaultTypography('Body Medium'),
      overflowSetting: {
        phone: getDefaultTypography('Body Small'),
        'phone-landscape': getDefaultTypography('Body Small'),
        tablet: getDefaultTypography('Body Small'),
        'tablet-landscape': getDefaultTypography('Body Small'),
        desktop: getDefaultTypography('Body Small'),
        tv: getDefaultTypography('Body Small'),
      },
    },
    'card-design-supporting-text-typography': {
      phone: getDefaultTypography('Body Medium'),
      'phone-landscape': getDefaultTypography('Body Medium'),
      tablet: getDefaultTypography('Body Medium'),
      'tablet-landscape': getDefaultTypography('Body Medium'),
      desktop: getDefaultTypography('Body Medium'),
      tv: getDefaultTypography('Body Medium'),
      overflowSetting: {
        phone: getDefaultTypography('Label Small'),
        'phone-landscape': getDefaultTypography('Label Small'),
        tablet: getDefaultTypography('Label Small'),
        'tablet-landscape': getDefaultTypography('Label Small'),
        desktop: getDefaultTypography('Label Small'),
        tv: getDefaultTypography('Label Small'),
      },
      detailPageSetting: {
        phone: getDefaultTypography('Label Small'),
        'phone-landscape': getDefaultTypography('Label Small'),
        tablet: getDefaultTypography('Label Small'),
        'tablet-landscape': getDefaultTypography('Label Small'),
        desktop: getDefaultTypography('Label Small'),
        tv: getDefaultTypography('Label Small'),
      },
    },
    'card-design-metadata-typography': {
      phone: getDefaultTypography('Body Small'),
      'phone-landscape': getDefaultTypography('Body Small'),
      tablet: getDefaultTypography('Body Small'),
      'tablet-landscape': getDefaultTypography('Body Small'),
      desktop: getDefaultTypography('Body Small'),
      tv: getDefaultTypography('Body Small'),
    },
    'card-design-action-help-typography': {
      phone: getDefaultTypography('Body Small'),
      'phone-landscape': getDefaultTypography('Body Small'),
      tablet: getDefaultTypography('Body Small'),
      'tablet-landscape': getDefaultTypography('Body Small'),
      desktop: getDefaultTypography('Body Small'),
      tv: getDefaultTypography('Body Small'),
    },
    'card-design-headline-typography': {
      phone: getDefaultTypography('headline-small'),
      'phone-landscape': getDefaultTypography('headline-small'),
      tablet: getDefaultTypography('headline-small'),
      'tablet-landscape': getDefaultTypography('headline-small'),
      desktop: getDefaultTypography('headline-small'),
      tv: getDefaultTypography('headline-small'),
    },
    'card-design-group-header-typography': {
      phone: getDefaultTypography('Title Medium'),
      'phone-landscape': getDefaultTypography('Title Medium'),
      tablet: getDefaultTypography('Title Medium'),
      'tablet-landscape': getDefaultTypography('Title Medium'),
      desktop: getDefaultTypography('Title Medium'),
      tv: getDefaultTypography('Title Medium'),
    },
  },

  // Text Manipulation
  // 'card-design-no-trunc': {
  //   phone: true,
  //   'phone-landscape': true,
  //   tablet: true,
  //   'tablet-landscape': true,
  //   desktop: true,
  //   tv: true,
  // },
  // Text Manipulation
  'card-design-title-lines': {
    phone: [1],
    'phone-landscape': [1],
    tablet: [2],
    'tablet-landscape': [2],
    desktop: [3],
    tv: [3],
    overflowSetting: getDefaultLineOverlay,
  },
  'card-design-subtitle-lines': {
    phone: [1],
    'phone-landscape': [1],
    tablet: [2],
    'tablet-landscape': [2],
    desktop: [3],
    tv: [3],
    overflowSetting: getDefaultLineOverlay,
  },
  'card-design-supporting-text-lines': {
    phone: [1],
    'phone-landscape': [1],
    tablet: [2],
    'tablet-landscape': [2],
    desktop: [3],
    tv: [3],
    overflowSetting: getDefaultLineOverlay,
  },
  'card-design-header-lines': {
    phone: [1],
    'phone-landscape': [1],
    tablet: [2],
    'tablet-landscape': [2],
    desktop: [3],
    tv: [3],
    overflowSetting: getDefaultLineOverlay,
  },
  'card-design-subheader-lines': {
    phone: [1],
    'phone-landscape': [1],
    tablet: [2],
    'tablet-landscape': [2],
    desktop: [3],
    tv: [3],
    overflowSetting: getDefaultLineOverlay,
  },
  'card-design-leading-button-scheme': {
    dark: 'primary-20',
    light: 'primary-20',
  },
  'card-design-trailing-button-scheme': {
    dark: 'secondary-40',
    light: 'secondary-40',
  },
  // text color
  'card-design-text-1-color': {
    dark: 'solid',
    light: 'solid',
  },
  'card-design-text-1-color-solid': {
    dark: 'primary-30',
    light: 'primary-30',
  },
  'card-design-text-1-color-start-gradient': {
    dark: 'primary-60',
    light: 'primary-60',
  },
  'card-design-text-1-color-end-gradient': {
    dark: 'primary-90',
    light: 'primary-90',
  },
  'card-design-text-1-color-gradient-direction': {
    dark: 'to-right',
    light: 'to-right',
  },
  'card-design-text-2-color': {
    dark: 'adaptive',
    light: 'adaptive',
  },
  'card-design-text-2-color-solid': {
    dark: 'primary-5',
    light: 'primary-5',
  },
  'card-design-text-2-color-start-gradient': {
    dark: 'primary-60',
    light: 'primary-60',
  },
  'card-design-text-2-color-end-gradient': {
    dark: 'primary-90',
    light: 'primary-90',
  },
  'card-design-text-2-color-gradient-direction': {
    dark: 'to-right',
    light: 'to-right',
  },
  'card-design-text-3-color': {
    dark: 'solid',
    light: 'solid',
  },
  'card-design-text-3-color-solid': {
    dark: 'primary-30',
    light: 'primary-30',
  },
  'card-design-text-3-color-start-gradient': {
    dark: 'primary-60',
    light: 'primary-60',
  },
  'card-design-text-3-color-end-gradient': {
    dark: 'primary-90',
    light: 'primary-90',
  },
  'card-design-text-3-color-gradient-direction': {
    dark: 'to-right',
    light: 'to-right',
  },
  'card-design-text-4-color': {
    dark: 'adaptive',
    light: 'adaptive',
  },
  'card-design-text-4-color-solid': {
    dark: 'primary-5',
    light: 'primary-5',
  },
  'card-design-text-4-color-start-gradient': {
    dark: 'primary-60',
    light: 'primary-60',
  },
  'card-design-text-4-color-end-gradient': {
    dark: 'primary-90',
    light: 'primary-90',
  },
  'card-design-text-4-color-gradient-direction': {
    dark: 'to-right',
    light: 'to-right',
  },
  'card-design-text-5-color': {
    dark: 'adaptive',
    light: 'adaptive',
  },
  'card-design-text-5-color-solid': {
    dark: 'primary-5',
    light: 'primary-5',
  },
  'card-design-text-5-color-start-gradient': {
    dark: 'primary-60',
    light: 'primary-60',
  },
  'card-design-text-5-color-end-gradient': {
    dark: 'primary-90',
    light: 'primary-90',
  },
  'card-design-text-5-color-gradient-direction': {
    dark: 'to-right',
    light: 'to-right',
  },
  'card-design-metadata-color': {
    dark: 'adaptive',
    light: 'adaptive',
  },
  'card-design-metadata-color-solid': {
    dark: 'primary-5',
    light: 'primary-5',
  },
  'card-design-metadata-color-start-gradient': {
    dark: 'primary-60',
    light: 'primary-60',
  },
  'card-design-metadata-color-end-gradient': {
    dark: 'primary-90',
    light: 'primary-90',
  },
  'card-design-metadata-color-gradient-direction': {
    dark: 'to-right',
    light: 'to-right',
  },
  'card-design-footer-area-color': {
    dark: 'adaptive',
    light: 'adaptive',
  },
  'card-design-footer-area-color-solid': {
    dark: 'primary-5',
    light: 'primary-5',
  },
  'card-design-footer-area-color-start-gradient': {
    dark: 'primary-60',
    light: 'primary-60',
  },
  'card-design-footer-area-color-end-gradient': {
    dark: 'primary-90',
    light: 'primary-90',
  },
  'card-design-footer-area-color-gradient-direction': {
    dark: 'to-right',
    light: 'to-right',
  },
  'card-design-media-icon-variant': {
    dark: 'filled',
    light: 'filled',
  },
  'card-design-media-icon-background-color-variant': {
    dark: 'primary-20',
    light: 'primary-70',
  },
  'card-design-media-icon-color-variant': {
    dark: 'primary-40',
    light: 'primary-90',
  },
  'card-design-media-icon-color-custom': {
    dark: false,
    light: false,
  },
  'card-design-media-icon-background-color-column': {
    dark: [200],
    light: [200],
  },
  'card-design-media-icon-color-column': {
    dark: 0,
    light: 0,
  },
}
